import { connect } from 'react-redux'
import { selectIsAddingNote } from 'selectors/page'
import { doRemoveDraftRecipients } from 'ducks/drafts'
import RecipientsEditor from './view'

const perform = {
  doRemoveDraftRecipients,
}

const selectFactory = (_, initialOwnProps) => {
  const { type, isForwarding } = initialOwnProps
  return state => {
    return {
      allowMultipleRecipients: type !== 'to' || isForwarding,
      forNote: selectIsAddingNote(state),
    }
  }
}

export default connect(selectFactory, perform)(RecipientsEditor)
